import styled from 'styled-components'
import { P } from 'components/common/P'

export const PriceWrapper = styled.div`
  display: flex;
`

export const PriceDetailsWithUnderwriterWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  img {
    width: 100px;
    height: 40px;
    object-fit: contain;
  }
  @media (max-width: 400px) {
    flex-wrap: wrap;
  }

  @media (max-width: 320px) {
    img {
      width: 50px;
      height: 20px;
    }
  }
`

export const UnderwriterImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`

export const PriceInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const PriceDetailsWrapper = styled.div`
  p {
    margin: 0;
    font-size: 14px;
  }

  h2 {
    font-size: 36px;
    margin: 0;
    text-align: left;
  }

  color: ${({ theme }) => theme.primaryTextColour};
  text-align: left;

  @media (max-width: 768px) {
    h2 {
      font-size: 34px;
    }
  }

  @media (max-width: 320px) {
    h2 {
      font-size: 24px;
    }
  }
`

export const PriceText = styled(P)`
  font-family: ${({ theme }) => theme.priceFontFamily};
  color: ${({ theme }) => theme.priceFontColour};
`

export const PriceTextLargeBold = styled(PriceText)`
  font-weight: bold;
  font-size: 36px !important;
`

export const PriceBeforeDiscount = styled(P)`
  color: red;
  font-weight: bold;
`

export const DiscountedPrice = styled(P)`
  font-size: 24px !important;
  font-weight: bold;
`
